import { render, staticRenderFns } from "./footer2.vue?vue&type=template&id=2e4c1dcc&"
import script from "./footer2.vue?vue&type=script&lang=js&"
export * from "./footer2.vue?vue&type=script&lang=js&"
import style0 from "./footer2.vue?vue&type=style&index=0&id=2e4c1dcc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports